interface ClientConfig {
  footerName: string;
  url: string;
  meta: {
    title: string;
    description: string;
  };
  zipName: string;
  brandName: string;
  environment: string;
}

export const clientConfig: ClientConfig = {
  footerName: import.meta.env.VITE_FOOTER_NAME,
  url: import.meta.env.VITE_FOOTER_URL,
  meta: {
    title: import.meta.env.VITE_HTML_META_TITLE,
    description: import.meta.env.VITE_HTML_META_DESCRIPTION
  },
  zipName: import.meta.env.VITE_ZIP_NAME,
  brandName: import.meta.env.VITE_BRAND_NAME,
  environment: import.meta.env.VITE_ENV
};
